<form [formGroup]="formGroup" class="form">
  <div class="title" *ngIf="this.title">{{ title }}</div>
  <div class="subtitle" *ngIf="this.subtitle">{{ this.subtitle }}</div>

  <div class="d-flex text-area">
    <mat-form-field class="wide" appearance="outline">
      <input
        type="number"
        class="number-input"
        placeholder="{{ placeholder }}"
        matInput
        formControlName="answer"
        (change)="answered()"
        required
      />
    </mat-form-field>
  </div>
</form>
